import classes from "./Search.module.css";

import GuestRooms from "./GuestRooms";
import BookingDatePicker from "./BookingDatePicker";
// import ReturningGuest from "./ReturningGuest";
import SearchButton from "./SearchButton";
import { useEffect } from "react";

const Search = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.formContainer}>
      <h2>Amity Wellness</h2>
      <h1>Price Quotation</h1>
      <div className={classes.searchDatesBox}>
        <BookingDatePicker />
      </div>
      <div className={classes.notesContainer}>
        <p className={`${classes.notesText} ${classes.noteIcon}`}>
          Please note: this calculator generates a quotation for the requested
          dates but doesn’t search availability (this is searched manually by
          our reservations team)
        </p>
      </div>

      <div className={classes.flexContainer}>
        <div className={classes.guestsRoomBox}>
          <GuestRooms />
        </div>
        <div className={classes.returningGuestContainer}>
          {/* <ReturningGuest /> */}
        </div>
      </div>
      <div className={classes.notesContainer}>
        <p className={`${classes.notesText} ${classes.noteIcon}`}>
          For bookings of 3 or more guests please contact us at
          info@amitywellness.com
        </p>
        <p className={`${classes.notesText} ${classes.noteIcon}`}>
          All bookings are subject to passing pre-screening requirements
        </p>
      </div>
      <div className={classes.searchButtonContainer}>
        <SearchButton />
      </div>
    </div>
  );
};

export default Search;
